module.exports = __webpack_public_path__ + "static/media/car1.932a9663.jpg";